import OnboardingStart from './OnboardingStart'

export default OnboardingStart
// eslint-disable-next-line import/export
export * from './OnboardingStart'
